/**
 * @file OAuthButtonsSlot.tsx
 *
 * @fileoverview Add Idowa oauth button.
 */

import React from 'react';
import { signIn } from 'next-auth/react';
import { FormattedMessage } from 'react-intl';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Button } from '~/vcl/atoms/01-forms/01-button';

const IdowaIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="1rem"
    height="1rem"
    viewBox="0 0 24 24"
  >
    <defs>
      <clipPath id="clip-idowa_jobiqo_icon">
        <rect width="24" height="24" />
      </clipPath>
    </defs>
    <g id="idowa_jobiqo_icon" clipPath="url(#clip-idowa_jobiqo_icon)">
      <path
        id="Differenzmenge_1"
        data-name="Differenzmenge 1"
        d="M24,24H6a6.007,6.007,0,0,1-6-6V0H18a6.007,6.007,0,0,1,6,6V24ZM10.541,7.767a.467.467,0,0,0-.466.467V20.507a.493.493,0,0,0,.466.493H12.7a.5.5,0,0,0,.466-.5V8.234a.467.467,0,0,0-.466-.467ZM10.494,3A.494.494,0,0,0,10,3.467V5.529A.494.494,0,0,0,10.494,6h2.29a.458.458,0,0,0,.455-.46V3.467A.468.468,0,0,0,12.772,3Z"
        fill="#fff"
      />
    </g>
  </svg>
);

export const OAuthButtonsSlot = ({
  gdpr,
  consentInfos,
  isRecruiterContext,
}) => {
  return (
    <>
      <Spacing />
      <Button
        buttonStyle="default"
        type="button"
        block={true}
        onClick={() => signIn('idowa', { callbackUrl: '/dashboard' })}
      >
        <IdowaIcon />{' '}
        <span>
          <FormattedMessage
            id="login_submit_idowa"
            defaultMessage={`Idowa Login *`}
          />
        </span>
      </Button>
    </>
  );
};
export default OAuthButtonsSlot;
